module.exports = __webpack_public_path__ + "img/MoDesk2.21dded91.png";